import React from "react";
import { connect } from "react-redux";
import SelectField from "react-md/lib/SelectFields";
import TextField from "react-md/lib/TextFields";
import FontIcon from "react-md/lib/FontIcons";
import Checkbox from "react-md/lib/SelectionControls/Checkbox";

import Buttons from "../Buttons";

import { setFilter, getRequestWithFilter } from "../../actions/requestActions";
import {REQUESTS} from "../../actions/constants";
import {DebugElement} from "../../Atollon/debug";
import {TouchCheckbox} from "../../AtollonTheme/ReactElements";

const options = [
  { label: "Datum vytvoření", value: "CREATED" },
  { label: "Datum změny", value: "MODIFIED" }
];

const options2 = [
  { label: "Kdykoliv", value: "ANY" },
  { label: "Dnes", value: "TODAY" },
  { label: "Včera", value: "YESTERDAY" },
  { label: "Tento týden", value: "THIS_WEEK" },
  { label: "Minulý týden", value: "PREVIOUS_WEEK" },
  { label: "Posledních 7 dní", value: "LAST_7_DAYS" },
  { label: "Posledních 14 dní", value: "LAST_14_DAYS" },
  { label: "Posledních 30 dní", value: "LAST_30_DAYS" },
  { label: "Tento měsíc", value: "THIS_MONTH" },
  { label: "Minulý měsíc", value: "PREVIOUS_MONTH" }
];

const RequestFilter = ( inputParameters ) => {

    let {
        history,
        title,
        primaryButtons,
        buttons,
        setFilter,
        filter,
        getRequestWithFilter,
        forMe,
        pageRequests,
        identifier
    } = inputParameters;

  return (
    <div className="flex-col margin-header">
        <DebugElement text={"src/components/requests/Header.js"}/>
      <div className="flex-row flex-spaced">
          <DebugElement text={"src/components/requests/Header.js -- SelectField"}/>
        <SelectField
          id="filterSelect"
          menuItems={options}
          itemLabel="label"
          itemValue="value"
          defaultValue="CREATED"
          position="below"
          onChange={value => {
            setFilter(
              filter.initial,
              filter.accepted,
              filter.resolving,
              filter.resolved,
              filter.closed,
              filter.dismissed,
              filter.textQuery,
              10,
              value,
              filter.date
            );
            getRequestWithFilter(
              pageRequests ? null : forMe ? "PENDING" : "NOT_PENDING",
              identifier,
              identifier
            );
          }}
        />
        <SelectField
          id="filterSelect2"
          menuItems={options2}
          itemLabel="label"
          itemValue="value"
          defaultValue="ANY"
          position="below"
          onChange={value => {
            setFilter(
              filter.initial,
              filter.accepted,
              filter.resolving,
              filter.resolved,
              filter.closed,
              filter.dismissed,
              filter.textQuery,
              10,
              filter.dateType,
              value
            );
            getRequestWithFilter(
              pageRequests ? null : forMe ? "PENDING" : "NOT_PENDING",
              identifier,
              identifier
            );
          }}
        />
        <div className="search">
          <TextField
            id="search"
            placeholder="Hledat"
            className="search-input"
            onChange={value => {
              setFilter(
                filter.initial,
                filter.accepted,
                filter.resolving,
                filter.resolved,
                filter.closed,
                filter.dismissed,
                value,
                10,
                filter.dateType,
                filter.date
              );
                /*

              global.store.dispatch({
                    type: REQUESTS,
                    payload: {
                        filter: {
                            initial: filter.initial,
                            accepted: filter.accepted,
                            resolving: filter.resolving,
                            resolved: filter.resolved,
                            closed: filter.closed,
                            dismissed: filter.dismissed,
                            textQuery: value,
                            limit: 10,
                            dateType: filter.dateType,
                            date: filter.date
                        }
                    }
              });
              */


              getRequestWithFilter(
                pageRequests ? null : forMe ? "PENDING" : "NOT_PENDING",
                identifier,
                identifier
              );
            }}
          />
          <FontIcon className="search-icon">search</FontIcon>
        </div>
      </div>
      <DebugElement text={"src/components/requests/Header.js -- Checkbox"}/>
      <div className="flex-row flex-spaced">
        <TouchCheckbox
          name="requestTypes"
          id="pending"
          label="Čekající"
          checked={filter.initial}
          onChange={value => {
            setFilter(
              value,
              filter.accepted,
              filter.resolving,
              filter.resolved,
              filter.closed,
              filter.dismissed,
              filter.textQuery,
              10,
              filter.dateType,
              filter.date
            );
            getRequestWithFilter(
              pageRequests ? null : forMe ? "PENDING" : "NOT_PENDING",
              identifier,
              identifier
            );
          }}
        />
        <TouchCheckbox
          name="requestTypes"
          id="accepted"
          label="Přijatý"
          checked={filter.accepted}
          onChange={value => {
            setFilter(
              filter.initial,
              value,
              filter.resolving,
              filter.resolved,
              filter.closed,
              filter.dismissed,
              filter.textQuery,
              10,
              filter.dateType,
              filter.date
            );
            getRequestWithFilter(
              pageRequests ? null : forMe ? "PENDING" : "NOT_PENDING",
              identifier,
              identifier
            );
          }}
        />
        <TouchCheckbox
          name="requestTypes"
          id="resolving"
          label="Řešený"
          checked={filter.resolving}
          onChange={value => {
            setFilter(
              filter.initial,
              filter.accepted,
              value,
              filter.resolved,
              filter.closed,
              filter.dismissed,
              filter.textQuery,
              10,
              filter.dateType,
              filter.date
            );
            getRequestWithFilter(
              pageRequests ? null : forMe ? "PENDING" : "NOT_PENDING",
              identifier,
              identifier
            );
          }}
        />
        <TouchCheckbox
          name="requestTypes"
          id="resolved"
          label="Vyřešený"
          checked={filter.resolved}
          onChange={value => {
            setFilter(
              filter.initial,
              filter.accepted,
              filter.resolving,
              value,
              filter.closed,
              filter.dismissed,
              filter.textQuery,
              10,
              filter.dateType,
              filter.date
            );
            getRequestWithFilter(
              pageRequests ? null : forMe ? "PENDING" : "NOT_PENDING",
              identifier,
              identifier
            );
          }}
        />
        <TouchCheckbox
          name="requestTypes"
          id="closed"
          label="Uzavřený"
          checked={filter.closed}
          onChange={value => {
            setFilter(
              filter.initial,
              filter.accepted,
              filter.resolving,
              filter.resolved,
              value,
              filter.dismissed,
              filter.textQuery,
              10,
              filter.dateType,
              filter.date
            );
            getRequestWithFilter(
              pageRequests ? null : forMe ? "PENDING" : "NOT_PENDING",
              identifier,
              identifier
            );
          }}
        />
        <TouchCheckbox
          name="requestTypes"
          id="dismissed"
          label="Zamítnutý"
          checked={filter.dismissed}
          onChange={value => {
            setFilter(
              filter.initial,
              filter.accepted,
              filter.resolving,
              filter.resolved,
              filter.closed,
              value,
              filter.textQuery,
              10,
              filter.dateType,
              filter.date
            );
            getRequestWithFilter(
              pageRequests ? null : forMe ? "PENDING" : "NOT_PENDING",
              identifier,
              identifier
            );
          }}
        />
      </div>
    </div>
  );
};

export default connect(({ request: { filter } }) => ({ filter }), {
  setFilter,
  getRequestWithFilter
})(RequestFilter);



// WEBPACK FOOTER //
// ./src/components/requests/RequestFilter.js